export default "__VITE_ASSET__8FnQRNf$__"